/**
 * Layout component 
 */

import React from "react"
import PropTypes from "prop-types"

import TeleworkHeader from "../teleworkheader"
import Footer from "../footer"
import TeleworkSEO from "../teleworkseo"

import styles from "./teleworklayout.module.css"
/*import "./itmodlayout.css"*/

const Layout = ({ children }) => {

  return (
    <>
      <TeleworkSEO title="Home" />
      <TeleworkHeader />
      <div className={`container ${styles.container}`}>
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout